<template>
  <vuePhoneInput
    ref="vuePhoneInput"
    class="vue-phone-input-wrapper"
    :code="parsedNumber.country"
    :value="parsedNumber.phone"
    :onChange="change"
    :class="disabled ? 'disabled' : ''"
    :disabled="disabled"
  ></vuePhoneInput>
</template>

<script>
import webcall from '@/libs/webcall';
import { asYouType } from 'libphonenumber-js';
import vuePhoneInput from './vue-phone-input';

export default {
  components: {
    vuePhoneInput,
  },
  props: {
    value: {
      default: '',
    },
    disabled: {
      default: false,
    },
  },
  computed: {
    parsedNumber() {
      const result = {
        country: '',
        phone: '',
      };

      if (this.formatter !== null && this.value) {
        this.formatter.input(this.value);
        result.country = (this.formatter.country) ? this.formatter.country.toLowerCase() : '';
        result.phone = this.formatter.national_number || '';
      }

      if (!result.country) {
        result.country = this.defaultCountryCode;
      }

      return result;
    },
  },
  data() {
    return {
      defaultCountryCode: '',
      formatter: null,
    };
  },
  methods: {
    change(phoneData) {
      if (phoneData.phone) {
        this.$emit('input', phoneData.value);
      }
    },
  },
  mounted() {
    /* eslint new-cap: 0 */

    webcall.app.getLocaleInformation()
      .then(({ data }) => {
        this.defaultCountryCode = data.country_code.toLowerCase();
        this.formatter = new asYouType(data.country_code);
        this.$refs.vuePhoneInput.setCode(this.parsedNumber.country);
        this.$refs.vuePhoneInput.phoneNumber = this.parsedNumber.phone;
      });
  },
};
</script>

<style lang="scss">
.vue-phone-input-wrapper.intl-phone-input {
  width: 100%;

  &.disabled {
    pointer-events: none;
  }

  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #c1c4cd;
  }
  input[type=number] {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 1;
    outline: none;
    padding-right: 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    box-shadow: none;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/TelInput/index.vue